import { Link } from "react-router-dom";

const values = [
  {
    i: "01",
    title: "Evidence over assumption",
    body: "We would rather show the proof than ask for trust. Every output links back to a primary source you can open yourself.",
  },
  {
    i: "02",
    title: "Access over gatekeeping",
    body: "The capabilities that compound money and influence should not sit behind a handful of institutions. We hand them to everyone.",
  },
  {
    i: "03",
    title: "Open over opaque",
    body: "We publish, we cite, and we build in the open, because power you cannot inspect is just a new gatekeeper.",
  },
];

function About() {
  return (
    <main className="ix-page">
      <header className="ix-hero center">
        <div className="ix-shell">
          <span className="ix-eyebrow">Our mission</span>
          <h1>
            Putting intelligence in <span className="red">everyone&rsquo;s hands.</span>
          </h1>
          <p className="ix-hero-lead">
            For a long time the tools that compound money and influence lived behind a
            few powerful players. Intellusion exists to change who holds them.
          </p>
        </div>
      </header>

      <section className="ix-section">
        <div className="ix-shell">
          <div className="ix-sec-head">
            <span className="ix-eyebrow is-gray">The story</span>
            <h2>A story of people helped.</h2>
          </div>
          <p
            style={{
              fontFamily: "var(--ix-disp)",
              fontWeight: 500,
              fontSize: "clamp(22px,2.6vw,32px)",
              lineHeight: 1.4,
              letterSpacing: "-0.4px",
              maxWidth: "980px",
              color: "var(--ix-ink)",
            }}
          >
            Institutional grade financial intelligence, research, and trusted networks
            were kept for the few.{" "}
            <span style={{ color: "var(--ix-faint)" }}>
              Everyone else got the summary, and was asked to trust it.
            </span>{" "}
            We build intelligent systems that give individuals the same edge the big
            players have, with every answer proven back to the source.
          </p>
        </div>
      </section>

      <section className="ix-section">
        <div className="ix-shell">
          <div className="ix-sec-head">
            <span className="ix-eyebrow is-gray">What we believe</span>
            <h2>Three commitments behind every product.</h2>
          </div>
          <div className="ix-grid-3">
            {values.map((v) => (
              <div className="ix-card" key={v.i}>
                <span className="ix-card-i">{v.i}</span>
                <h4 style={{ fontSize: "21px", margin: "14px 0 10px" }}>{v.title}</h4>
                <p style={{ fontSize: "15px" }}>{v.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ix-section">
        <div className="ix-shell">
          <div className="ix-sec-head">
            <span className="ix-eyebrow">What we do</span>
            <h2>We design intelligent systems for the problems that matter.</h2>
            <p>
              Starting with StockLens, our financial intelligence platform that turns
              company filings, policy records, and ownership data into clear, source
              traced answers anyone can verify.
            </p>
          </div>
          <Link to="/projects" className="ix-link">
            See the products →
          </Link>
        </div>
      </section>
    </main>
  );
}

export default About;
